<template>
  <div class="confirmInput"  ref="confirmDiv">
    <el-input
      class="confirmInput-edit"
      ref="inputELm"
      v-bind="$attrs"
      v-on="$listeners"
      @keyup.enter.native="onConfirm"
    >
    </el-input>
    <el-button type="text" size="mini" @click="onConfirm">确定</el-button>
    <el-button type="text" size="mini" @click="onCancel">取消</el-button>
  </div>
</template>
<script>
export default {
  name: "ConfirmInput",
  data() {
    return {
      inputValue: ""
    };
  },
  methods: {
    focus() {
      const inputRef = this.$refs.inputELm;
      inputRef && inputRef.focus();
    },
    onConfirm() {
      this.$emit("confirm");
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
};
</script>
<style lang="scss" scoped>
.confirmInput{
  display:flex;
  &-edit{
    width: 200px;
    margin-right:10px;
  }
}
</style>
